let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9g8ap")).then(() => parcelRequire('jXUXW'));